export default "__VITE_ASSET__D8FXZrS3__"